
import Catalogo from "@/mixins/catalogo";
import RULES from "@/mixins/rules";
import {mapGetters} from "vuex";
import { solicitudArrendamiento } from "@/models/solicitudArrendamiento";
import EstablecimientoService from '@/services/EstablecimientoService';
import SolicitudArrendamientoService from '@/services/SolicitudArrendamientoService';

export default Catalogo.extend({
    name: "FormsolicitudArrendamiento",
    mixins: [RULES],
    data() {
        return {
            mercados: [],
            formdata: new solicitudArrendamiento(),
            showInputSolid: false,
            showInputAlta: false,
            documento: Document || null,
            dialogPdfView:false,
            establecimientos:[],
            giros:[],
            menu1: false,
            menu2: false,
        };
    },
    computed: {
        ...mapGetters({
            usuario: "usuario",
            id: "id",
            contribuyente: "contribuyente",
            mini: "sidebar",
        }),
    },
    methods: {
        async viewpdf(id: any,titulo: any) {
      const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

      let file = new Blob([response.data],{type: response.headers['content-type']});
      const url = window.URL.createObjectURL(file);
      this.documento = {
                    //@ts-ignore
                    title: titulo,
                    url: url,
                    mime: response.headers['content-type']
                }
              this.dialogPdfView=true;
      //window.open(url, '_blank', 'noreferrer');
    },
        async getData() {
            if(this.formdata.contrato_arrendamiento_id>0){
                this.showInputSolid = false;
            }
        },
        setDocument(e: any, type: number) {
            const fileReader = new FileReader();
            fileReader.addEventListener("load", () => {
                var file = fileReader.result;
                if (type == 1)
                //@ts-ignore
                this.formdata.docContrato_arrendamiento = file + "";
        });
        if (e != null)
        fileReader.readAsDataURL(e);
        },
        cancelChangeFile(file: any) {
      if (file == 1)
        this.showInputSolid = false;
    },
    changeFile(file: any) {
        if (file == 1)
        this.showInputSolid = true;
    },
    guardar() {
            let data = null;
        
            if (this.form.validate()) {
                if(this.formdata.fecha_inicio == null || this.formdata.fecha_inicio == ''){
                this.$toast.error('La fecha de inicio es requerida');
                return
            }
            if(this.formdata.fecha_fin == null || this.formdata.fecha_fin == ''){
                this.$toast.error('La fecha final es requerida');
                return
            }
            if(this.formdata.renta_mes == null || this.formdata.renta_mes == 0){
                this.$toast.error('El monto de renta mensual es requerido');
                return
            }
                if(this.formdata.contrato_arrendamiento_id!=null){
                    SolicitudArrendamientoService.update(this.formdata)
                    .then((response) => {
                    if (response.data.success) {
                        this.close(true);
                        this.$toast.success(response.data.message);
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo enviar la solicitud.")
                });
                }
                else{
                    SolicitudArrendamientoService.create(this.formdata)
                    .then((response) => {
                    if (response.data.success) {
                    this.close(true);
                        this.$toast.success(response.data.message);
                        this.getData();
                    } else {
                        this.$toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    this.$toast.error("No se pudo enviar la solicitud.")
                });
                }
            }
        },
        cambiamonto(){
            if(this.formdata.renta_mes != null || this.formdata.renta_mes !='' || this.formdata.renta_mes !=0){
                let t=(this.formdata.renta_mes*0.1);
            this.formdata.porcen_ayunta =parseFloat(t.toFixed(2));
            }else{
                this.formdata.porcen_ayunta = 0;
            }
           
    },
    },
    watch: {
    dialog(val) {
      if(this.dialog) {
        this.getData();
      }
    },
  },
    mounted() {
        this.getData();
    },
});
